import {Button, Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import ImageUI from 'ui/ImageUI';

interface IProps {
  rating?: number;
  onChange: (value: number) => void;
  t: (term: TranslationKeys) => string;
}

const listBtn = [
  {grade: 3, srcImage: '/diseLike.svg', title: 'DISLIKE'},
  {grade: 5, srcImage: '/like.svg', title: 'LIKE'},
];

export const Grade: FC<IProps> = ({rating, onChange, t}) => {
  return (
    <Flex borderRadius="16px" p="3px 8px" justifyContent="center" m="20px 0">
      {listBtn.map(({title, srcImage, grade}, index) => {
        const grateRating = rating === grade;
        const description = title as TranslationKeys;

        return (
          <Flex key={index} flexDirection="column" justifyContent="center" alignItems="center" mx={['6px', '20px']}>
            <Button
              cursor="pointer"
              w="100px"
              h="100px"
              bg={grateRating ? colors.pink : colors.lightGray}
              border="2px solid black"
              borderRadius="50%"
              onClick={() => onChange(grade)}
              _hover={{bg: colors.pink}}
            >
              <ImageUI src={srcImage} alt="grate" />
            </Button>

            <Text fontWeight="600" fontSize="14px" mt="8px" textAlign="center">
              {t(`${description}`)}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
